import { SxProps } from "@mui/material";

export const sxTextMinorHomeBanner: SxProps = {
  fontFamily: "Montserrat-Regular",
  maxWidth: "310px",
};
